import { TextButtonContainer } from './textButton.styles'
import { TextButtonProps } from './textButton.types'

const TextButton = ({
    text,
    dataTestId,
    onClick,
    fontSizeVariant = 's-regular',
    padding,
}: TextButtonProps) => {
    return (
        <TextButtonContainer
            data-testid={dataTestId ?? 'text-button'}
            onClick={onClick}
            fontSizeVariant={fontSizeVariant}
            padding={padding}
        >
            {text}
        </TextButtonContainer>
    )
}

export default TextButton
